import { render, staticRenderFns } from "./ClientesNoPeriodo.vue?vue&type=template&id=72fb607a&"
import script from "./ClientesNoPeriodo.vue?vue&type=script&lang=js&"
export * from "./ClientesNoPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports